"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const hiddenScroll = document.querySelector("body");
    const header = document.querySelector(".o-header");
    const menu = document.querySelector(".mobile-menu");
    const buttonMenu = menu.querySelector(".contact-us_button");
    buttonMenu.addEventListener("click", () => {
        menu.classList.remove("active");
        hiddenScroll.style.overflow = "auto";
    });
    hamburguer.addEventListener("click", () => {
        header.classList.remove("active");
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
    });
}
